import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question:
      "Why should I choose TekRevol for mobile app development in Qatar?",
    answer: `<p>As a leading app development company in Qatar, TekRevol is dedicated to empowering businesses through cutting-edge technology and digital solutions. Our team of experts works with clients to develop comprehensive development plans and reliable digital strategies, enabling them to become future-ready and grow sustainably. Our commitment to delivering top-quality services and exceptional customer support has made us a trusted choice for app development in Qatar. In addition, we offer ongoing support and maintenance services to ensure the success of our client's apps. Let's connect to learn how we can help turn your app idea into a reality.</p>`,
  },
  {
    question: "How much will it cost to build my app?",
    answer: `<p>Developing an application with fundamental features, like a calculator or flashlight app, may incur costs ranging from $10,000 to $40,000 or beyond. In contrast, the development of more intricate apps, such as those for social media or e-commerce, can involve expenses ranging from $30,000 to $500,000 or higher.</p>`,
  },
  {
    question:
      " How do I hire a mobile app development company to build an app?",
    answer: `<p>Explore our simple roadmap to initiate the process of developing a new mobile app:</p>   
        <ul>
        <li>Assemble a team.</li>
        <li>Research competitors</li>
        <li>Identify crucial features</li>
        <li>Create mockups</li>
        <li>Plan app security</li>
        <li>Begin coding</li>
        <li>Execute thorough testing</li>
        <li>Gather and implement feedback.</li>
        </ul> `,
  },
  {
    question:
      " How can I build mobile apps for both iOS and Android using the same source code?",
    answer: ` <p>TekRevol offers cross-platform app development services to enable businesses to reach a wider audience across iOS and Android platforms. This cost-effective solution allows app entrepreneurs to develop iOS and Android apps using the same source code, reducing development time and costs. Get in touch to learn how our cross-platform app development services can help you succeed as an app entrepreneur.</p>`,
  },
  {
    question:
      "  Does TekRevol offer post-launch support and app maintenance services?",
    answer: ` <p>Yes, we offer exceptional post-launch support to our clients in Qatar to quickly address any concerns of end users. At TekRevol, we believe every satisfied customer is an asset and can help us strengthen our credibility and build a reputation as an industry leader. We are ready to go above and beyond to help you build a scalable and sustainable app business.</p>`,
  },
  {
    question: " I have an app idea. Where should I start?",
    answer: ` <p>TekRevol is here to help bring your app idea to life! Our highly skilled design and development teams will assist you in every step of the development process, ensuring a smooth and successful launch. If you believe your app has the potential to succeed in the app stores, we offer free consultation sessions to discuss your project in detail and provide a customized project roadmap and cost estimate. Let's connect to book your free discovery session and take the first step toward realizing your app's potential.</p>`,
  },
  {
    question: "Where are we located in Qatar?",
    answer: `<p>Facilitating businesses globally, TekRevol is recognized as an international brand helping its clients digitize their process through mobile app development. We are located at “Tornado Tower, Level 22, Doha, Qatar” So, you can consult with us to discuss your project idea and we can help you sharpen it into something that creates value for your business and the customers on the other end.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
